import { create } from 'zustand';

export type QuickAddDialogKey =
  | 'employee'
  | 'boat'
  | 'engine'
  | 'trailer'
  | 'lead'
  | 'quote'
  | 'customer'
  | 'work_order';

interface QuickAddState {
  active: QuickAddDialogKey | null;
  open: (key: QuickAddDialogKey) => void;
  close: () => void;
}

export const useQuickAddStore = create<QuickAddState>((set) => ({
  active: null,
  open: (key) => set({ active: key }),
  close: () => set({ active: null }),
}));
